document.addEventListener('DOMContentLoaded', function(){

  $('body').on('click', '.quick-atc', function(e){
      e.preventDefault();
      e.stopImmediatePropagation();
      e.stopPropagation();

      var items = [{
          quantity: 1,
          id: parseInt( $(this).attr('data-product-id') )
      }];
      $.post('/cart/add.js', { items: items }).always(function(){
          document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: { items: items } }));
      });
      
      return false;
  });
  
  $('body').on('click', '.bis-trigger', function(e){
    e.preventDefault();
    $('.klaviyo-product-container[data-klaviyo-handle="' + $(this).attr('data-klaviyo-handle') + '"]').find('.klaviyo-bis-trigger')[0].click();
    return false;
  });

});